import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyGroupState {
  id: string;
  name: string;
  isActive: boolean;
  props: {
    [key: string]: any;
  };
}

const initialState: CompanyGroupState = {
  id: '',
  name: '',
  isActive: false,
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const companyGroupSlice = createSlice({
  name: 'companyGroup',
  initialState,
  reducers: {
    setCompanyGroup: (state, action: PayloadAction<Partial<CompanyGroupState>>) => {
      return { ...state, ...action.payload };
    },

    resetCompanyGroup: (_state, action: PayloadAction<Partial<CompanyGroupState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: CompanyGroupState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setCompanyGroup, resetCompanyGroup, updateField, updateProps } = companyGroupSlice.actions;

export default companyGroupSlice.reducer;
